import React from 'react'
import styled from '@emotion/styled'
import { array, object, string } from 'prop-types'
import { makeImgResizerUrl } from '@jelly/utils'

// Import Components
import { CardForContentSummary } from '@jelly/components'

// Styled Components via Emotion
const ArticlesWrapper = styled.div`
	display: block;
	margin-top: 2rem;
	flex-direction: row;
	flex-wrap: wrap;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		display: flex;
	}
`
const Article = styled.div`
	font-size: 18px;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		width: 50%;
	}
`

const TrendingArticlesContainer = styled.section`
	display: block;
	grid-column: span 2;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		margin: 2rem 0;
	}
`

TrendingArticles.propTypes = {
	articles: array,
	sponsor: object,
	title: string.isRequired,
}

/**
 * This is the Trending Articles section
 * @param {Array} props.articles Trending articles array containing article objects
 * @param {Object} props.sponsor Data for hub sponsor
 * @param {String} props.title Data for section title
 */
export function TrendingArticles({ articles, sponsor, title }) {
	return (
		<TrendingArticlesContainer>
			<h2>{title}</h2>
			<ArticlesWrapper>
				{articles.map(
					({ author, isSponsored, subtitle, editorsPick, canonical, title, thumbnail, sponsorship }) => (
						<Article key={title}>
							<CardForContentSummary
								author={author}
								blurb={null}
								docType={editorsPick && 'editorsPick'}
								inTrendingArticles={true}
								outerUrl={canonical}
								sponsor={
									isSponsored && sponsorship.sponsorType === 'single-sponsor' ? sponsorship : sponsor
								}
								isSponsored={isSponsored}
								subtitle={subtitle}
								thumbnail={makeImgResizerUrl({
									src: thumbnail && thumbnail.path,
									method: 'rc',
									w: 100,
									h: 75,
								})}
								title={title}
							/>
						</Article>
					)
				)}
			</ArticlesWrapper>
		</TrendingArticlesContainer>
	)
}
